import { SafeCombobox as Combobox } from '../../../../components/Common/SafeCombobox';
import React, { useRef } from 'react';
import useGetFromServer from '../../../../utils/useGetFromServer';

export default function Titles({ getTitles, initialValue, selectedYear }) {
  const params = new URLSearchParams({ selectedYear: selectedYear ?? new Date().getFullYear() });
  const { data } = useGetFromServer(`quoteTitles?${params}`, [selectedYear]);
  const selected = useRef(initialValue ? initialValue.map((title, index) => ({ id: index, label: title })).filter(item => !!item.label) : [])

  return (
    <Combobox
      multiSelect
      label='Select Titles'
      onSelect={(selection) => {
        selected.current = selection;
        getTitles(selection.map((title) => title));
      }}
      selected={selected.current}
    >
      {data.map((title, i) => <Combobox.Option key={`${i}-${title}`} id={i} label={title} />)}
    </Combobox>
  );
}
